export { default } from "./DashText";
